import { useCookies } from 'react-cookie'
import Cookies from 'universal-cookie'

import ScryfallDeckFilter from 'components/deckPage/filtersAndControls/DeckFilter/SyntaxDeckFilter'
import ArchidektDeckFilter from 'components/deckPage/filtersAndControls/DeckFilter/ArchidektDeckFilter'
import ArchidektDropdown from 'components/elements/ArchidektDropdown'
import PhatButton from 'components/formElements/PhatButton'
import Icon, { IconTypes } from 'components/elements/Icon'

import styles from './deckFilter.module.scss'
import { expirationDurations } from 'services/cookie.service'

const FILTER_COOKIE_KEY = 'filterType'

const DeckFilter = () => {
  const [{ filterType: filterType = 'archidekt' }, setCookies] = useCookies([FILTER_COOKIE_KEY])

  const setFilterType = (filterType: 'archidekt' | 'syntax') => {
    setCookies(FILTER_COOKIE_KEY, filterType, {
      path: '/',
      expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 40),
    })

    // react-cookie doesn't support high priority
    const cookies = new Cookies()

    cookies.set(FILTER_COOKIE_KEY, filterType, {
      path: '/',
      maxAge: expirationDurations.year,
      sameSite: 'lax',
      httpOnly: false,
      // @ts-ignore - high priority cookie is a thing
      priority: 'High',
    })
  }

  return (
    <div className={styles.container}>
      {filterType === 'syntax' && <ScryfallDeckFilter className={styles.deckFilter} />}
      {filterType === 'archidekt' && <ArchidektDeckFilter className={styles.deckFilter} />}
      <ArchidektDropdown
        menuClassName={styles.changeFilterMenu}
        options={[
          {
            label: 'Local deck filter',
            id: 'archidekt',
            icon: filterType === 'archidekt' ? ('circle check' as IconTypes) : ('circle outline' as IconTypes),
            onClick: () => setFilterType('archidekt'),
          },
          {
            label: 'Syntax deck filter',
            id: 'syntax',
            icon: filterType === 'syntax' ? ('circle check' as IconTypes) : ('circle outline' as IconTypes),
            onClick: () => setFilterType('syntax'),
          },
        ]}>
        <PhatButton className={styles.changeFilterTrigger}>
          <Icon name="cog" />
        </PhatButton>
      </ArchidektDropdown>
    </div>
  )
}

export default DeckFilter
